<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="用户ID"></el-input>
      </el-form-item>
          <el-form-item label="流水号" prop="bizFlow">
          <el-input v-model="dataForm.bizFlow" placeholder="流水号"></el-input>
      </el-form-item>
          <el-form-item label="对账状态" prop="reconStatus">
          <el-input v-model="dataForm.reconStatus" placeholder="对账状态"></el-input>
      </el-form-item>
          <el-form-item label="类型 产生这条记录的操作" prop="type">
          <el-input v-model="dataForm.type" placeholder="类型 产生这条记录的操作"></el-input>
      </el-form-item>
          <el-form-item label="账户总额" prop="total">
          <el-input v-model="dataForm.total" placeholder="账户总额"></el-input>
      </el-form-item>
          <el-form-item label="操作金额" prop="money">
          <el-input v-model="dataForm.money" placeholder="操作金额"></el-input>
      </el-form-item>
          <el-form-item label="可用金额" prop="useMoney">
          <el-input v-model="dataForm.useMoney" placeholder="可用金额"></el-input>
      </el-form-item>
          <el-form-item label="冻结金额" prop="noUseMoney">
          <el-input v-model="dataForm.noUseMoney" placeholder="冻结金额"></el-input>
      </el-form-item>
          <el-form-item label="活期累计收益" prop="collection">
          <el-input v-model="dataForm.collection" placeholder="活期累计收益"></el-input>
      </el-form-item>
          <el-form-item label="交易对方的user_id" prop="toUser">
          <el-input v-model="dataForm.toUser" placeholder="交易对方的user_id"></el-input>
      </el-form-item>
          <el-form-item label="资金记录类型" prop="name">
          <el-input v-model="dataForm.name" placeholder="资金记录类型"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
          <el-form-item label="添加时间" prop="addTime">
          <!-- <el-input v-model="dataForm.addTime" placeholder="添加时间"></el-input> -->
          <el-date-picker
                  v-model="dataForm.addTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="添加IP" prop="addIp">
          <el-input v-model="dataForm.addIp" placeholder="添加IP"></el-input>
      </el-form-item>
          <el-form-item label="收支明细 0：不变  1：收入  2：支出, 3: 充值 ,4: 提现" prop="paymentsType">
          <el-input v-model="dataForm.paymentsType" placeholder="收支明细 0：不变  1：收入  2：支出, 3: 充值 ,4: 提现"></el-input>
      </el-form-item>
          <el-form-item label="交易结果0：交易中；1：成功；2：失败" prop="tradeStatus">
          <el-input v-model="dataForm.tradeStatus" placeholder="交易结果0：交易中；1：成功；2：失败"></el-input>
      </el-form-item>
      <el-form-item label="关联外键，更新使用" prop="keyId">
          <el-input v-model="dataForm.keyId" placeholder="关联外键，更新使用"></el-input>
      </el-form-item>
          <el-form-item label="0：显示-1不显示" prop="showStatus">
          <el-input v-model="dataForm.showStatus" placeholder="0：显示-1不显示"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        bizFlow: '',
        reconStatus: '',
        type: '',
        total: '',
        money: '',
        useMoney: '',
        noUseMoney: '',
        collection: '',
        toUser: '',
        name: '',
        remark: '',
        addTime: '',
        addIp: '',
        paymentsType: '',
        tradeStatus: '',
        keyId: '',
        showStatus: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bizFlow: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reconStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        total: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        useMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        noUseMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        collection: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        toUser: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addIp: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        paymentsType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        tradeStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        keyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        showStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slaccountlog/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slaccountlog/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
